import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, ...props }, ref) => {
    const inputId = id || React.useId()
    return (
      <label htmlFor={inputId} className="flex cursor-pointer items-start gap-2">
        <span className="relative mt-0.5 flex size-4 shrink-0 items-center justify-center">
          <input
            id={inputId}
            type="checkbox"
            ref={ref}
            className={cn(
              'peer size-4 shrink-0 appearance-none rounded border border-input bg-background checked:border-primary checked:bg-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
              className,
            )}
            {...props}
          />
          <Check className="pointer-events-none absolute size-3 text-primary-foreground opacity-0 peer-checked:opacity-100" />
        </span>
        {label ? <span className="text-sm leading-snug">{label}</span> : null}
      </label>
    )
  },
)
Checkbox.displayName = 'Checkbox'

export { Checkbox }
